// Symbol.iterator of Matreshka.Object instances
export default function matreshkaObjectIterator() {
  var _this = this;
  var keys = this.keys();
  var i = 0;
  var result = {
    next: function next() {
      if (i > keys.length - 1) {
        // no value, as before
        return {
          done: true
        };
      }
      return {
        done: false,
        value: _this[keys[i++]]
      };
    }
  };
  result[Symbol.iterator] = function () {
    return result;
  };
  return result;
}